module.exports = __webpack_public_path__ + "img/teacher-authorize-refresh.88f189e8.svg";